"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.expirationValidaton = exports.dateRegex = exports.POBoxRegex = exports.throwError = exports.isError = exports.formatPhoneNumber = exports.formatDateString = exports.formatNumber = exports.PersonAccountHelpers = exports.validators = exports.formatDateToString = void 0;
const validator_1 = __importDefault(require("validator"));
const formatDateToString = (date) => {
    return [
        String(date.getFullYear()),
        String(101 + date.getMonth()).substring(1),
        String(100 + date.getDate()).substring(1),
    ].join('-');
};
exports.formatDateToString = formatDateToString;
var validators;
(function (validators) {
    validators.isEmail = (value) => validators.isString(value) && validator_1.default.isEmail(value);
    validators.isPhone = (value) => validators.isString(value) && validator_1.default.isMobilePhone(value);
    validators.isString = (value) => typeof value === 'string';
    validators.isBoolean = (value) => typeof value === 'boolean';
    validators.isDate = (value) => validators.isString(value) && validator_1.default.isDate(value);
    validators.isJWT = (value) => validators.isString(value) && validator_1.default.isJWT(value);
    validators.isValidPassword = (value) => {
        var _a, _b;
        if (validators.isString(value)) {
            const containsValidCharacters = (value.match(/[^a-zA-Z0-9@#$%^&*-_!+=\[\]{}|\\:',.?/`~"();<>]/g) === null);
            const isValidLength = value.length >= 8 && value.length <= 256;
            const characterCount = ((_a = value.match(validators.validLettersAndSymbols)) === null || _a === void 0 ? void 0 : _a.length) || 0;
            const numberCount = ((_b = value.match(validators.numbersRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0;
            const containsValidNumberOfNumbersAndLetters = characterCount > 0 && numberCount > 0;
            return containsValidCharacters && isValidLength && containsValidNumberOfNumbersAndLetters;
        }
        return false;
    };
    validators.validLettersAndSymbols = /[a-zA-Z@#$%^&*\-_!+=\[\]{}|\\:',.?/`~"();<>]/g;
    validators.numbersRegex = /[0-9]/g;
    let MyProfileFieldValidators;
    (function (MyProfileFieldValidators) {
        MyProfileFieldValidators.isPreferredContactMethod = (val) => {
            if (!validators.isString(val)) {
                return false;
            }
            const valAs = val;
            if (valAs === 'Email' || valAs === 'Mail' || valAs === 'Home' || valAs === 'Mobile' || valAs === 'Work') {
                return true;
            }
            return false;
        };
    })(MyProfileFieldValidators = validators.MyProfileFieldValidators || (validators.MyProfileFieldValidators = {}));
})(validators || (exports.validators = validators = {}));
var PersonAccountHelpers;
(function (PersonAccountHelpers) {
    PersonAccountHelpers.findMobilePhone = (personDetails) => {
        const primaryPhone = personDetails.phones.Primary;
        const secondaryPhone = personDetails.phones.Secondary;
        if (primaryPhone.phoneType === 'mobile') {
            return primaryPhone.phoneNumber;
        }
        if ((secondaryPhone === null || secondaryPhone === void 0 ? void 0 : secondaryPhone.phoneType) === 'mobile') {
            return secondaryPhone.phoneNumber;
        }
    };
    PersonAccountHelpers.findPhoneType = (personDetails) => {
        const primaryPhone = personDetails.phones.Primary;
        const secondaryPhone = personDetails.phones.Secondary;
        if (primaryPhone.phoneType === 'mobile') {
            return primaryPhone.phoneNumber;
        }
        if ((secondaryPhone === null || secondaryPhone === void 0 ? void 0 : secondaryPhone.phoneType) === 'mobile') {
            return secondaryPhone.phoneNumber;
        }
    };
})(PersonAccountHelpers || (exports.PersonAccountHelpers = PersonAccountHelpers = {}));
const formatNumber = (n) => {
    return n === null || n === void 0 ? void 0 : n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.formatNumber = formatNumber;
const formatDateString = (dateString) => {
    if (dateString) {
        let date = new Date(dateString);
        return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
    }
};
exports.formatDateString = formatDateString;
const formatPhoneNumber = (phoneNumber) => `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
exports.formatPhoneNumber = formatPhoneNumber;
const isError = (error) => {
    const errorObj = error;
    if (errorObj.message === undefined) {
        return false;
    }
    if (errorObj.name === undefined) {
        return false;
    }
    return true;
};
exports.isError = isError;
const throwError = (err) => {
    if ((0, exports.isError)(err)) {
        throw new Error(err.message);
    }
    if (typeof err === 'string') {
        throw new Error(err);
    }
};
exports.throwError = throwError;
exports.POBoxRegex = /^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i;
// Used for date filters
exports.dateRegex = /^([1-9]|1[0-2])\/([1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
const expirationValidaton = (value) => {
    const dateObj = new Date();
    const currentMonth = dateObj.getUTCMonth() + 1; //months from 1-12
    const year = dateObj.getUTCFullYear().toString();
    const currentYear = year.slice(2, 4);
    const currentValue = value.split("/").join("");
    const enterYear = currentValue.slice(2, 4);
    const enterMonth = currentValue.slice(0, 2);
    if (Number(enterMonth) > 12 || Number(enterYear) < Number(currentYear)) {
        return "Please enter a valid date in MM/YY format";
    }
    if (Number(enterYear) === Number(currentYear)) {
        if (Number(enterMonth) < currentMonth) {
            return "Please enter a valid date in MM/YY format";
        }
    }
};
exports.expirationValidaton = expirationValidaton;
